<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalOverview",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>5. (i) What was the AVERAGE total value during the last 12 months of</div>"
					},
					bindTo: ""
				},
				{
					label:
						"(a) Your own stock and bank notes? (The stock figure is to be declared on the basis of cost price or on the basis as in question 4 above)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0StockBankNotesAverageValueId",
					props: {
						suggest: {
							typeIncludes: "stockBankNotesAverageValue"
						},
						createOptions: {
							type: "stockBankNotesAverageValue",
							dataType: "string"
						}
					}
				},
				{
					label:
						"(b) Goods in trust (other than for sale custody) goods on approval, repairs and the like?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0GoodsInTrustAverageValueId",
					props: {
						suggest: {
							typeIncludes: "goodsInTrustAverageValue"
						},
						createOptions: {
							type: "goodsInTrustAverageValue",
							dataType: "string"
						}
					}
				},
				{
					label: "The TOTAL under (a) and (b) comprises approximately",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0StockBankNotesGoodsInTrustSumValueId",
					props: {
						suggest: {
							typeIncludes: "stockBankNotesGoodsInTrustSumValue"
						},
						createOptions: {
							type: "stockBankNotesGoodsInTrustSumValue",
							dataType: "string"
						}
					}
				},
				{
					label:
						"Jewellery, gold and platinum goods, bullion, precious stones and pearls",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0JewelleryValueId",
					props: {
						suggest: {
							typeIncludes: "jewelleryValue"
						},
						createOptions: {
							type: "jewelleryValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Watches",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0WatchesValueId",
					props: {
						suggest: {
							typeIncludes: "watchesValue"
						},
						createOptions: {
							type: "watchesValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Clocks, silverware, plateware, and other similar goods",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0ClocksValueId",
					props: {
						suggest: {
							typeIncludes: "clocksValue"
						},
						createOptions: {
							type: "clocksValue",
							dataType: "string"
						}
					}
				},
				{
					label:
						"5. (ii) What was the MAXIMUM value of your own stock and goods in trust (other than for safe custody) and bank notes at any time during the 12 months?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0StockBankNotesGoodsInTrustMaxValueId",
					props: {
						suggest: {
							typeIncludes: "stockBankNotesGoodsInTrustMaxValue"
						},
						createOptions: {
							type: "stockBankNotesGoodsInTrustMaxValue",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
